import { render, staticRenderFns } from "./PopupHowToWrite.vue?vue&type=template&id=2273d97f&scoped=true"
import script from "./PopupHowToWrite.vue?vue&type=script&lang=js"
export * from "./PopupHowToWrite.vue?vue&type=script&lang=js"
import style0 from "./PopupHowToWrite.vue?vue&type=style&index=0&id=2273d97f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273d97f",
  null
  
)

export default component.exports